module.exports = __webpack_public_path__ + "public/images/iterable-email-capture-box.6b32bbe2f677539f8e3227d2d2ad84f3.webp";